export const CREATE_GROUP_SCREEN = {
  CREATE_GROUP: 1,
  ADD_FILES: 2,
  ADD_FILES_CONTAINER_MOBILE: 3,
  ADD_FILES_FROM_MOBILE: 4,
  ADD_MEMBERS_TO: 5,
  SUCCESSFULLY_SHARED: 6
};
